import { Component, OnInit } from '@angular/core';
import { AdbookingService } from '../services/adbooking.service';
import { UserdataService } from '../services/userdata.service';
import { VieworderService } from '../services/vieworder.service';
import { OrderstatusService } from '../services/orderstatus.service';
import { PaymentdetailsService } from '../search-booking/paymentdetailstab.service';

@Component({
  selector: 'app-vieworder',
  templateUrl: './vieworder.component.html',
  styleUrls: ['./vieworder.component.css']
})
export class VieworderComponent implements OnInit {

 orderdetails: object;
 orderid: any;
 user: { userdata: any; };


  searchorder: any;
  selectedItem: any;
  filename: any;
  email: any;
  status:any;
  ordercancel:number=102;
  router: any;
  adContent: any;
  location: any;
  bookingdetail: any;
  adtype: any;
  adpage: any;
  adsize: any;
  adcategory: any;
  noofdays: any;
  addate: any;
  freedays: any;
  frees: any;
  imagename: any;
  totalCost: any;
  free: any;
  adcost: any;
  paymentdetails: any;
  payment_method: any;
  gst_number:string;


  constructor(
    private userdataservice: UserdataService,private paymentdetailsService:PaymentdetailsService,
    private Vieworderservice: VieworderService, private adbookingservice: AdbookingService,private Orderstatusservice: OrderstatusService) {

  }
  ngOnInit() {

    this.userdataservice.getUserDataSubject().subscribe(data => {
      this.email = data['email'];
   });

    this.orderid = this.Vieworderservice.getVieworderdata();
    console.log(this.orderid);
    this.status = this.Orderstatusservice.getOrderstatus();


    //  this.userdataservice.getUserDataSubject().subscribe(data => {
    //   this.email = data['email'];
    //   console.log(this.email);

    this.paymentdetailsService.getadcustdetails(this.orderid).subscribe(
      resp => {
        this.bookingdetail = resp.bookingdetails;
        this.email = this.bookingdetail.email;
        this.adtype = this.bookingdetail.adtype;
        this.adpage = this.bookingdetail.adpage;
        this.adsize = this.bookingdetail.adsize;
        this.orderid = this.bookingdetail.orderid;
        this.adcategory = this.bookingdetail.adcategory;
         this.noofdays = this.bookingdetail.noofdays;
         this.addate = this.bookingdetail.addate;
        //  this.igst = (this.bookingdetail.igst).toFixed(2);
         this.adcost = (this.bookingdetail.adcost).toFixed(2);
         this.totalCost = (this.bookingdetail.totalCost).toFixed(2);
         this.imagename = this.bookingdetail.imagename;
         this.adContent = this.bookingdetail.adContent;
         this.status = this.bookingdetail.status;
         this.free = this.bookingdetail.free;
         this.frees = this.bookingdetail.frees;
         this.freedays = this.bookingdetail.freedays;
         this.location = this.bookingdetail.location;
         this.gst_number = this.bookingdetail.gstnumber;
         console.log(this.email)
         console.log(this.status)
         console.log(this.freedays)

         this.paymentdetails = resp.paymentdetails;
         this.payment_method = this.paymentdetails.payment_method;

          

        //  this.customerdetail =resp.customerdetails;
        //  this.username = this.customerdetail.username;
        //  this.mobilenumber = this.customerdetail.mobilenumber;
      
        
      
          this.searchorder = resp;
          console.log(this.searchorder)
        
  
      });

  }


  download(imagename) {
    this.adbookingservice.getFile(this.email, this.orderid, imagename).subscribe(
      resp => {
        console.log(resp);
        const downloadURL = window.URL.createObjectURL(resp);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = imagename;
        link.click();
        link.remove();
      });
  }



//   onSelect(selectedItem: any) {
cancel(){
  this.adbookingservice.cancelOrder(this.orderid,this.ordercancel).subscribe(
    resp => {
      console.log(resp);
       
       if(resp.success==true){
         this.status=102;
       }
       
    });
    
}

}
